import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { createTheme } from '@mui/material';
import theme from './theme';
export const CustomThemeContext = React.createContext(null);
const CustomThemeProvider = ({ children, modes, storageProvider }) => {
    // const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
    const [darkMode, setDarkMode] = storageProvider('dark-mode', false);
    const mainTheme = createTheme(theme(darkMode, modes));
    const handleToggleDarkMode = () => {
        setDarkMode((i) => !i);
    };
    const contextItems = {
        darkMode,
        setDarkMode,
        toggleDarkMode: handleToggleDarkMode,
    };
    return (_jsx(CustomThemeContext.Provider, Object.assign({ value: contextItems }, { children: _jsx(StyledEngineProvider, Object.assign({ injectFirst: true }, { children: _jsx(ThemeProvider, Object.assign({ theme: mainTheme }, { children: children })) })) })));
};
export default CustomThemeProvider;
//# sourceMappingURL=index.js.map